import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

import { Facility } from '../interfaces/facility';

@Injectable({
  providedIn: 'root',
})
export class FacilitiesAdapter {
  private http = inject(HttpClient);

  getFacilities(): Observable<any> {
    return this.http.get(`${environment.apiBaseUrl}/company/facilities`);
  }

  createFacility(
    facility: Pick<Facility, 'hereId' | 'headquarters'>
  ): Observable<Exclude<Facility, 'hereId' | 'headquarters'>> {
    return this.http.post<Exclude<Facility, 'hereId' | 'headquarters'>>(
      `${environment.apiBaseUrl}/company/facilities`,
      facility
    );
  }

  editFacility(facility: Pick<Facility, 'id' | 'hereId' | 'headquarters'>) {
    return this.http.patch(`${environment.apiBaseUrl}/company/facilities/${facility.id}`, {
      hereId: facility.hereId,
      headquarters: facility.headquarters,
    });
  }

  deleteFacility(facility: Facility): Observable<any> {
    return this.http.delete(`${environment.apiBaseUrl}/company/facilities/${facility.id}`);
  }
}
